import { NUTRITION_STATS } from "../../data/promill";

export const NutritionStrip = () => (
    <section
        data-testid="nutrition-strip"
        className="bg-pm-black text-white py-14 md:py-20 border-y-4 border-pm-orange relative overflow-hidden"
    >
        <div aria-hidden className="absolute -top-32 -right-32 w-96 h-96 bg-pm-orange/15 rounded-full blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-10">
                <span className="text-pm-yellow font-bold tracking-[0.3em] uppercase text-xs">
                    Nutrition you can see
                </span>
                <h2 className="mt-2 font-display text-4xl md:text-6xl uppercase">
                    No hidden <span className="text-pm-orange">nasties.</span>
                </h2>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {NUTRITION_STATS.map((s, i) => (
                    <div
                        key={s.label}
                        data-testid={`nutrition-stat-${i}`}
                        className="text-center border-2 border-pm-yellow/30 rounded-2xl py-8 hover:border-pm-yellow hover:bg-pm-yellow/5 transition-colors"
                    >
                        <div className="font-display text-6xl md:text-7xl text-pm-yellow leading-none">
                            {s.value}
                        </div>
                        <div className="mt-3 text-xs md:text-sm uppercase tracking-[0.2em] text-white/70">
                            {s.label}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);
